import { render, staticRenderFns } from "./PeriodsTable.vue?vue&type=template&id=03d61ef7&scoped=true&"
import script from "./PeriodsTable.vue?vue&type=script&lang=js&"
export * from "./PeriodsTable.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsTable.vue?vue&type=style&index=0&id=03d61ef7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d61ef7",
  null
  
)

export default component.exports